// For Sticky Header and Footer CTAs with different messages
document.addEventListener("DOMContentLoaded", function () {
  // Product title
  const productTitle =
    document.querySelector(".m-product-title")?.innerText || "Product";

  // Product URL
  const productLink = window.location.href;

  // ===== HEADER MESSAGE =====
  const headerMessage = `Hello EverMore Store!

I came from Sticky Header.
${productLink}`;

  // ===== RETURN MESSAGE =====
  const returnMessage = `Hi EverMore Team, I want to exchange/return my order.

Order ID:
Reason for Exchange/Return:
Product Name:
Registered Mobile Number:`;

  // ===== PDP MESSAGE =====
  const pdpMessage = `Hi EverMore Team,

I saw your product on the website:

${productTitle}

${productLink}

and I’m interested in it. Could you please provide more details about the product, such as its features, pricing, and availability? I would also like to know if there are any ongoing promotions or discounts for this product.

Thank you!`;

  // Set WhatsApp Links safely with existence checks
  const headerWhatsapp = document.getElementById("whatsapp-header") || document.getElementById("start-chat-link");
  if (headerWhatsapp) {
    headerWhatsapp.href = `https://wa.me/919974900634?text=${encodeURIComponent(headerMessage)}`;
  }

  const pdpWhatsapp = document.getElementById("whatsapp-pdp");
  if (pdpWhatsapp) {
    pdpWhatsapp.href = `https://wa.me/919974900634?text=${encodeURIComponent(pdpMessage)}`;
  }

  const returnWhatsapp = document.getElementById("return");
  if (returnWhatsapp) {
    returnWhatsapp.href = `https://wa.me/919974900634?text=${encodeURIComponent(returnMessage)}`;
  }
});
